<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">
        <!-- Login -->
        <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <div class="d-flex justify-content-center flex-column">
                    <a class="mb-2 text-center" target="_blank" href="https://www.autosys.mx/">
                        <img src="assets/images/logo/logo.png" height="125" alt="">
                    </a>
                    <p class="text-primary m-0 text-center" style="font-size: 14px;">
                        AUTO CARTA PORTES
                    </p>
                    <p class="m-0 text-center" style="font-size: 11px;">
                        SOFTWARE PARA CARTAS PORTE Y FACTURACIÓN
                    </p>
                </div>
                <h2 class="card-title font-weight-bold mb-1 text-center text-primary mt-4">
                    Iniciar sesión
                </h2>
                <p class="card-text mb-2 text-center">Bienvenidos a Auto Carta Portes</p>
                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>
                <form class="auth-login-form mt-2" [formGroup]="_loginForm" (ngSubmit)="onLogin()">
                    <div class="form-group">
                        <label class="form-label" for="email">Correo Electrónico</label>
                        <input type="text"
                               formControlName="email"
                               id="email"
                               class="form-control"
                               [ngClass]="{ 'is-invalid error': _submitted && controls.email.errors }"
                               placeholder="email@autocartaporte.com"
                               aria-describedby="login-email"
                               autofocus=""
                               tabindex="1"/>
                        <div *ngIf="_submitted && controls.email.errors" class="invalid-feedback">
                            <div *ngIf="controls.email.errors.required">
                                Correo Electrónico es requerido
                            </div>
                            <div *ngIf="controls.email.errors.email">
                                El correo debe ser una dirección de correo electrónico válida
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="password">Contraseña</label>
                            <!--                            <a routerLink="/pages/authentication/forgot-password-v2">-->
                            <!--                                <small>¿Olvidó su contraseña?</small>-->
                            <!--                            </a>-->
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="_passwordTextType ? 'text' : 'password'"
                                   formControlName="password"
                                   id="password"
                                   class="form-control form-control-merge"
                                   [ngClass]="{ 'is-invalid error': _submitted && controls.password.errors }"
                                   placeholder="············"
                                   aria-describedby="login-password"
                                   tabindex="2"/>
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <i class="feather font-small-4"
                                       [ngClass]="{ 'icon-eye-off': _passwordTextType, 'icon-eye': !_passwordTextType}"
                                       (click)="togglePasswordTextType()">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="_submitted && controls.password.errors"
                             class="invalid-feedback"
                             [ngClass]="{ 'd-block': _submitted && controls.password.errors }">
                            <div *ngIf="controls.password.errors.required">
                                Contraseña es requerida
                            </div>
                            <div *ngIf="controls.password.errors.minlength">
                                La contraseña debe tener al
                                menos {{ controls.password.errors.minlength.requiredLength }} caracteres
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3"/>
                            <label class="custom-control-label" for="remember-me">Recordar contraseña</label>
                        </div>
                    </div>
                    <button [disabled]="_loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                        <span *ngIf="_loading" class="spinner-border spinner-border-sm mr-1"></span>Iniciar Sesión
                    </button>
                </form>
                <p class="text-center mt-2">
                    <span>Copyright © {{ year }} AUTO CARTA PORTES</span><br>
                    <span>Todos los derechos reservados</span><br>
                    Desarrollado por
                    <a target="_blank" href="https://www.dosbytes.com.mx/">
                        <span>dosbytes.com.mx</span>
                    </a>
                </p>
            </div>
        </div>
        <!-- Login End-->

        <!-- Left Text-->
        <div class="d-none d-lg-flex col-lg-8 align-items-center justify-content-center">
            <div class="w-100 d-lg-flex align-items-center justify-content-center justify-content-center flex-column">
                <img class="position-fixed zindex-minus-1"
                     [src]="'assets/images/pages/img_login.png'"
                     alt="Login V2"/>
                <p class="text-center text-white zindex-1">
                    <b class="m-2" style="font-size: 2.5rem; font-weight: 600;">
                        AUTO CARTA PORTES
                    </b>
                </p>
                <p class="text-center text-white zindex-1 mt-1" style="font-size: 1.5rem;">
                    Software para Cartas Porte y Facturación.
                </p>
            </div>
        </div>
        <!-- Left Text End -->
    </div>
</div>
